<template>
  <div class="chat-msg" :class="`chat-msg--${message.role}`">
    <div class="chat-msg__bubble">
      <div v-if="message.role === 'assistant'" v-html="html"></div>
      <span v-else>{{ message.content }}</span>
    </div>
    <ChatPropertyCards
      v-if="message.properties && message.properties.length"
      :properties="message.properties"
    />
  </div>
</template>

<script>
import { renderMarkdown } from '../../utils/markdown'
import ChatPropertyCards from './ChatPropertyCards.vue'

export default {
  name: 'ChatMessage',
  components: { ChatPropertyCards },
  props: {
    message: { type: Object, required: true }
  },
  computed: {
    html () {
      return renderMarkdown(this.message.content)
    }
  }
}
</script>

<style scoped>
.chat-msg {
  margin-bottom: 14px;
}
.chat-msg__bubble {
  display: inline-block;
  max-width: 88%;
  padding: 10px 14px;
  border-radius: 16px;
  line-height: 1.5;
  font-size: 15px;
  word-break: break-word;
  overflow-wrap: anywhere;
}
.chat-msg--user {
  text-align: right;
}
.chat-msg--user .chat-msg__bubble {
  background: #E45726;
  color: #fff;
  border-bottom-right-radius: 4px;
  text-align: left;
}
.chat-msg--assistant .chat-msg__bubble {
  background: #F1F3F5;
  color: #1D262D;
  border-bottom-left-radius: 4px;
}
.chat-msg--error .chat-msg__bubble {
  background: #FDECEA;
  color: #B3261E;
  border: 1px solid #F5C6C0;
}
</style>

<style>
/* Estilos del markdown renderizado (v-html, no puede ser scoped) */
.chat-msg .md-content > *:first-child { margin-top: 0; }
.chat-msg .md-content > *:last-child { margin-bottom: 0; }
.chat-msg .md-content p { margin: 0 0 8px; }
.chat-msg .md-heading { margin: 12px 0 6px; font-size: 16px; font-weight: 700; }
.chat-msg .md-list { margin: 0 0 8px; padding-left: 20px; list-style: disc; }
.chat-msg .md-list li { margin-bottom: 4px; }
.chat-msg .md-content code {
  background: rgba(29, 38, 45, 0.08);
  padding: 1px 5px;
  border-radius: 4px;
  font-size: 13px;
}
.chat-msg .md-content a { color: #E45726; text-decoration: underline; overflow-wrap: anywhere; }
.chat-msg--user .md-content a { color: #fff; }
</style>
